"use client";

import { ChevronRight } from "lucide-react";
import { AeraButton } from "@/app/components/ui/AeraButton";

export type SuggestSection = {
  screen_title?: string;
  layout?: string;
  elements?: Array<{
    type?: string;
    data?: { label?: string };
    [key: string]: unknown;
  }>;
};

export function SuggestedActions({
  suggestSection,
  isUser,
  disabled,
  onSelect,
}: {
  suggestSection?: SuggestSection | null;
  isUser: boolean;
  disabled: boolean;
  onSelect: (label: string) => void;
}) {
  if (!suggestSection || isUser) return null;

  return (
    <div className="mt-3 w-full animate-in fade-in slide-in-from-bottom-2 duration-500 delay-150 fill-mode-forwards">
      {suggestSection.screen_title && (
        <div className="text-xs font-semibold text-aera-charcoal mb-2.5 px-1 uppercase tracking-wider">
          {suggestSection.screen_title}
        </div>
      )}

      <div
        className={`flex ${suggestSection.layout === "vertical" ? "flex-col items-start" : "flex-row flex-wrap"} gap-2.5`}
      >
        {suggestSection.elements?.map((element, idx) => {
          if (element.type !== "action_button") return null;

          const label = element.data?.label ?? "";

          return (
            <AeraButton
              key={idx}
              variant="outline"
              size="xs"
              paddingSize="xxs"
              onClick={() => onSelect(label)}
              disabled={disabled}
              className="group relative active:scale-[0.98] max-w-full"
              icon={
                <div className="w-1.5 h-1.5 rounded-full bg-aera-lightgray group-hover:bg-aera-amber transition-colors" />
              }
              iconRight={
                <ChevronRight
                  size={16}
                  strokeWidth={2}
                  className="h-4 text-aera-gray group-hover:text-aera-gray transition-all duration-200 ease-in-out ml-auto w-0 opacity-0 -translate-x-1 group-hover:w-4 group-hover:opacity-100 group-hover:translate-x-0 overflow-hidden"
                  aria-hidden
                />
              }
            >
              <span className="text-left">{label}</span>
            </AeraButton>
          );
        })}
      </div>
    </div>
  );
}

